import { render } from "./mitigateTable.vue?vue&type=template&id=370164a0&scoped=true"
import script from "./mitigateTable.vue?vue&type=script&lang=js"
export * from "./mitigateTable.vue?vue&type=script&lang=js"

import "./mitigateTable.vue?vue&type=style&index=0&id=370164a0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370164a0"]])

export default __exports__